import { useQuery } from '@tanstack/react-query';
import { type MeResponse } from '@intone/shared';
import { useApiClient } from '@/shared/api';

export function useUser(orgId: string | null | undefined ) {
	const apiClient = useApiClient();

	return useQuery({
		queryKey: ['me', orgId],
		queryFn: async () => apiClient<MeResponse>('/me'),
		enabled: !!orgId,
    staleTime: 1000 * 60 * 5, // 5 minutes
		refetchOnWindowFocus: false,
	});
}